import { IconName, icons } from "./icons"
import { HTMLProps } from "react"

interface Props extends HTMLProps<SVGSVGElement> {
	name: IconName
	size?: number
}

export const Icon = ({ name, size, ...props }: Props) => {
	size = size || 22

	const SVGIcon = icons[name]
	return <SVGIcon fill="currentColor" width={size} height={size} {...props} />
}
